
import { Vue, Component } from 'vue-property-decorator';
import ApplicationFooter from '@/components/ApplicationFooter.vue';
import { readDashboardMiniDrawer, readDashboardShowDrawer, readHasAdminAccess, readUserCompany } from '@/store/main/getters';
import { commitSetDashboardShowDrawer } from '@/store/main/mutations';
import { dispatchGetUserCompany, dispatchUserLogOut } from '@/store/main/actions';

const routeGuardMain = async (to, from, next) => {
  if (to.path === '/main') {
    next('/main/dashboard');
  } else {
    next();
  }
};

@Component({
  components: {
    ApplicationFooter,
  }
})
export default class Main extends Vue {
  public footer_year = 0;

  get getCompanyName() {
    const user_company = readUserCompany(this.$store);
    return (user_company) ? user_company.name : '';
  }

  public async mounted() {
    this.footer_year = this.getYear();
    await dispatchGetUserCompany(this.$store);
  }

  public async created() {
    commitSetDashboardShowDrawer(this.$store, false);
  }

  public beforeRouteEnter(to, from, next) {
    routeGuardMain(to, from, next);
  }

  public beforeRouteUpdate(to, from, next) {
    routeGuardMain(to, from, next);
  }

  get miniDrawer() {
    return readDashboardMiniDrawer(this.$store);
  }

  get showDrawer() {
    return readDashboardShowDrawer(this.$store);
  }

  set showDrawer(value) {
    commitSetDashboardShowDrawer(this.$store, value);
  }

  public switchShowDrawer() {
    commitSetDashboardShowDrawer(
      this.$store,
      !readDashboardShowDrawer(this.$store),
    );
  }

  // public switchMiniDrawer() {
  //   commitSetDashboardMiniDrawer(
  //     this.$store,
  //     !readDashboardMiniDrawer(this.$store),
  //   );
  // }

  public get hasAdminAccess() {
    return readHasAdminAccess(this.$store);
  }

  public async logout() {
    await dispatchUserLogOut(this.$store);
  }

  public guide() { }

  public getYear(): number {
    let date = new Date();
    return date.getFullYear();
  }
}
